export const enum ESourceType {
    ORGANIC = "organic",
    PAID = "paid",
    ALL = "all",
}

export interface SearchKeywordsData {
    numOfKeywords: string;
    changeOfKeywords: number;
}
export type BrandedSplitData = {
    [key in "branded" | "nonBranded"]: FormattedNumber;
};
export interface FormattedNumber {
    formattedValue: string;
    numericValue: number;
}

export type QueryParams = {
    country: string;
    from: string;
    to: string;
    keys: string;
    webSource: string;
    SourceType?: ESourceType;
};
export interface DomainInfo {
    name: string;
    favicon: string;
    url: string;
}
export type SwitcherItem = {
    title: string;
    value: string;
    changeFilter: string;
    tooltipText?: string;
};
